// הסמן העגול — inova <mouse-cursor>. הנימוקים ב-theme/snippets/mouse-cursor.liquid
// 🔁 163.0 item 13 (Head 73.0 GO A): the source's MouseCursor - on every mousemove, once per frame (its rAF throttle), the circle moves
// 1/4 of the way to the pointer, so it trails and stops where the last move left it (review-163/i13: 4 steps -187.5 / 40 steps -4.1).
// Two zones: the open cart drawer's dim (header) and the open filter drawer's overlay (collection-inova, 640..1279 with a mouse).
// `data-mouse-cursor-on` on <html> while the circle is shown - the zones hide the system cursor ONLY then (no JS / touch = system cursor).
// Reduced motion (Elad Q1 "ב", 10.10): the circle follows the pointer exactly, no trailing (its size change jumps - the CSS).
(function () {
    var el = document.querySelector('[data-mouse-cursor]');
    if (!el) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    // 163.0: rendered inside the header section (sticky, z-index 18 = its own stacking context), so z-index 50 was capped there and the
    // filter drawer (z 60) painted over the circle (review-163/i13/z_13.mjs). The source's <mouse-cursor> sits at body level - move it there.
    if (el.parentElement !== document.body) document.body.appendChild(el);

    // 🔁 166.0 #75b (Head 76.0 GO): the cart is a MODAL dialog at every width (#75) - it lives in the top layer and painted over this
    // circle (a body child). The circle is a manual popover (popover + inert, mouse-cursor.liquid) and enters the top layer AFTER the
    // dialog (theme-drawer:open fires after showModal), so it paints above it; hidden again on close and on pagehide.
    var cart = document.querySelector('theme-drawer#cart-drawer');
    var cartDialog = cart ? cart.querySelector('dialog') : null;
    function unpop() {
      try { if (el.matches(':popover-open')) el.hidePopover(); } catch (err) { /* no popover support: nothing was shown */ }
    }
    if (cart && el.showPopover) {
      cart.addEventListener('theme-drawer:open', function () {
        unpop();
        try { el.showPopover(); } catch (err) { /* no popover support: the circle stays under the dialog */ }
      });
      cart.addEventListener('theme-drawer:close', function () { show(false); unpop(); });
      window.addEventListener('pagehide', unpop);
    }
    var root = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var posX = 0;
    var posY = 0;
    var last = null;
    var raf = 0;

    function over(x, y) {
      var hit = document.elementFromPoint(x, y);
      if (!hit || !hit.closest) return false;
      // 163.0: the filter drawer's overlay, only while the drawer is open
      var ov = hit.closest('[data-cino-drawer-overlay]');
      if (ov) return !!ov.closest('.cino__drawer.is-open');
      // 🔁 166.0 #75b: the modal cart's ::backdrop hit-tests as the DIALOG element itself - the zone = the dialog hit outside its box
      // (was: theme-drawer::before, the wrapper hit while a drawer was open)
      if (hit === cartDialog && cartDialog.open && cart.hasAttribute('open')) {
        var r = cartDialog.getBoundingClientRect();
        return x < r.left || x > r.right || y < r.top || y > r.bottom;
      }
      return false;
    }

    // 163.0 (Head 73.0 flag): write only when the state changes - an attribute on <html> restyles the page's :has() rules (#41 / 157.0)
    var shown = false;
    function show(on) {
      if (on === shown) return;
      shown = on;
      el.classList.toggle('active', on);
      el.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) root.setAttribute('data-mouse-cursor-on', '');
      else root.removeAttribute('data-mouse-cursor-on');
      if (!on) el.classList.remove('pressed');
    }

    function frame() {
      raf = 0;
      var e = last;
      if (reduce.matches) {
        posX = e.clientX;
        posY = e.clientY;
      } else {
        posX += (e.clientX - posX) / 4;
        posY += (e.clientY - posY) / 4;
      }
      // 218.0: posX / posY follow clientX / Y = DRAWN px; --x / --y feed a LAYOUT translate - / the cursor's zoom (MDN
      // Element.currentCSSZoom; 1 below 1280) - the hotspot-linea 4ad56cd0 helper. Measured (Home 24 TABLE24 #8): at pointer x .65 at 1518.
      var z = el.currentCSSZoom || 1;
      el.style.setProperty('--x', posX / z + 'px');
      el.style.setProperty('--y', posY / z + 'px');
      show(over(e.clientX, e.clientY));
    }

    document.addEventListener(
      'mousemove',
      function (e) {
        last = e;
        if (!raf) raf = requestAnimationFrame(frame);
      },
      { passive: true }
    );
    document.addEventListener('mousedown', function () {
      if (el.classList.contains('active')) el.classList.add('pressed');
    });
    document.addEventListener('mouseup', function () {
      el.classList.remove('pressed');
    });
    document.addEventListener('mouseleave', function () {
      show(false);
    });
  })();
